import { ReactElement } from 'react'
import family from './assets/image.png'
import * as S from './styled'

export default function About (): ReactElement {
  return <S.Container id="quem-somos">
    <S.Content>
      <S.TextContent>
        <h1>Quem somos</h1>

        <p>O <strong>programa Esportes Soft</strong> é um benefício acoplado ao sócio-torcedor de alguns clubes do futebol brasileiro. </p>

        <S.ImageContainer className="mobile">
          <img src={family} alt="" />
        </S.ImageContainer>

        <span><strong>Desenvolvido exclusivamente para os clubes</strong> como benefícios a seus sócios-torcedores, o <strong>programa Esportes Soft</strong> oferece <strong>desconto</strong> em <strong>consultas médicas, exames, farmácias</strong> e <strong>cursos</strong> na Refuturiza, além de experiências <strong>exclusivas com seu time do coração</strong>.</span>
      </S.TextContent>

      <S.ImageContainer className="desktop">
        <img src={family} alt="" />
      </S.ImageContainer>
    </S.Content>
  </S.Container>
}
